module.exports = __webpack_public_path__ + "img/chr_ts_90_19.0cdac61d.png";